import { render, staticRenderFns } from "./single-decision.vue?vue&type=template&id=774c9204&scoped=true&"
import script from "./single-decision.vue?vue&type=script&lang=js&"
export * from "./single-decision.vue?vue&type=script&lang=js&"
import style0 from "./single-decision.vue?vue&type=style&index=0&id=774c9204&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774c9204",
  null
  
)

export default component.exports